var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgStandby(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 12C0 11.3997 0.486647 10.9131 1.08696 10.9131H22.913C23.5133 10.9131 24 11.3997 24 12C24 12.6004 23.5133 13.087 22.913 13.087H1.08696C0.486647 13.087 0 12.6004 0 12Z",
    fill: "#0F20E8"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.9991 0C12.5994 0 13.086 0.486647 13.086 1.08696V22.913C13.086 23.5134 12.5994 24 11.9991 24C11.3988 24 10.9121 23.5134 10.9121 22.913V1.08696C10.9121 0.486647 11.3988 0 11.9991 0Z",
    fill: "#0F20E8"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.0003 6.40243C8.90867 6.40243 6.40243 8.90868 6.40243 12.0003C6.40243 15.0919 8.90866 17.5981 12.0003 17.5981C15.0919 17.5981 17.5981 15.0919 17.5981 12.0003C17.5981 8.90868 15.0918 6.40243 12.0003 6.40243ZM4.22852 12.0003C4.22852 7.70807 7.70805 4.22852 12.0003 4.22852C16.2925 4.22852 19.772 7.70807 19.772 12.0003C19.772 16.2925 16.2925 19.772 12.0003 19.772C7.70806 19.772 4.22852 16.2925 4.22852 12.0003Z",
    fill: "#0F20E8"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStandby);
export default __webpack_public_path__ + "static/media/standby.1d8290a8309bc9cdab44b93f2cd6ff6c.svg";
export { ForwardRef as ReactComponent };